import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface Props {}

const CompliancyFilter: FC<Props> = () => {
	const { setValue, control } = useFormContext<ReportDetailForm>();

	const { showCompliantReport } = useWatch({
		control,
		name: "filters"
	});

	return (
		<div data-testid="component.CompliancyFilter">
			<div className="flex w-full sm:w-auto bg-white border border-border p-1.5 rounded-xl shadow-xs">
				<button
					className={[
						"flex-1 sm:flex-none px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200",
						showCompliantReport
							? "bg-primary text-white shadow-md shadow-primary/50"
							: "text-zinc-600 hover:text-zinc-800 hover:bg-white/80"
					].join(" ")}
					onClick={() => setValue("filters.showCompliantReport", true)}
				>
					Compliant
				</button>

				<button
					className={[
						"flex-1 sm:flex-none px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200",
						!showCompliantReport
							? "bg-primary text-white shadow-md shadow-primary/50"
							: "text-zinc-600 hover:text-zinc-800 hover:bg-white/80"
					].join(" ")}
					data-testid="set-complete-btn"
					onClick={() => setValue("filters.showCompliantReport", false)}
				>
					Completed
				</button>
			</div>
		</div>
	);
};

export default CompliancyFilter;
